/*@ngInject*/
const AppTypeConfigurationModel = function ($q, coreConstant, authorizationConstants, clientType, userTypeConstant) {

    let consoleType = null,
        userType = null,
        channelMappings = {
            'Agent': 'allAgents',
            'Underwriter': 'allUws',
            'ServiceUser': 'allSUs'
        },
        consoleTitleMappings = {
            'umagent': 'homePage.agentTitle',
            'um': 'homePage.underwriterTitle',
            'umstudio': 'homePage.umStudioTitle',
            'appreader': 'homePage.appreaderTitle'
        };

    this.setConsoleType = function (type) {
        consoleType = type;
    };

    this.getConsoleType = function () {
        return consoleType;
    };

    this.getConsoleTypeAuthorizationName = function () {
        let result,
            consoleType = this.getConsoleType();

        if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT) {
            result = authorizationConstants.LOGIN_AGENT_WORKSPACE;
        }
        else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM) {
            result = authorizationConstants.LOGIN_UNDERWRITER_WORKSTATION;
        }
        else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
            result = authorizationConstants.LOGIN_CONFIGURATOR;
        }
        else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_APPREADER) {
            result = authorizationConstants.LOGIN_APPREADER;
        }

        return result;
    };

    this.appendConsoleType = function (key) {
        return key + '::' + this.getConsoleType();
    };

    this.setUserType = function (type) {
        userType = type;
    };

    this.getUserType = function () {
        return userType;
    };

    this.isAgentConsole = function () {
        return (userType === userTypeConstant.AGENT);
    };

    this.isUnderwriterWorkstation = function () {
        return (userType === userTypeConstant.UNDERWRITER || userType === userTypeConstant.SERVICEUSER);
    };

    this.isAdminWorkstation = function () {
        return (userType === userTypeConstant.SYSTEMUSER);
    };

    this.clearUserType = function () {
        userType = null;
    };

    this.getAllChannel = function () {
        return channelMappings[userType];
    };

    this.getConsoleTitleKey = function () {
        return consoleTitleMappings[consoleType];
    };

    this.getApplicationId = function () {
        let applicationId;

        if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT) {
            applicationId = clientType.UM_HTML_AGENT;
        }
        else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM) {
            applicationId = clientType.UM_HTML_UW;
        }
        else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO) {
            applicationId = clientType.UM_STUDIO;
        }
        else if (consoleType === coreConstant.authorization.CONSOLE_TYPE_APPREADER) {
            applicationId = clientType.APP_READER;
        }

        return applicationId;
    };
};

angular.module('umCore').service('appTypeConfigurationModel', AppTypeConfigurationModel);
